import { z } from "zod";
import { isValidDate } from "../../../../../../../../../../../../../utils/dateValidate";
import { isGreaterThanTime, isValidTime } from "../../../../../../../../../../../../../utils/timeValidate";

export const schema = z
    .object({
        setor: z.string().min(1, { message: "Setor é obrigatório" }),
        fila: z.string().min(1, { message: "Fila é obrigatória" }),
        servico: z.string().min(1, { message: "Serviço é obrigatório" }),
        data: z.string().min(10, { message: "Data é obrigatória" }),
        tempo_presencial: z.string().min(1, { message: "Tempo de atendimento presencial é obrigatório" }),
        tempo_online: z.string().min(1, { message: "Tempo de atendimento online é obrigatório" }),
        horario_especial_agendamento: z.boolean().default(false),
        hora_inicio_agendamento: z.string().nullable(),
        hora_fim_agendamento: z.string().nullable(),
        intervalo_hora_inicio_agendamento: z.string().nullable(),
        intervalo_hora_fim_agendamento: z.string().nullable(),
        horario_especial_diario: z.boolean().default(false),
        hora_inicio_diario: z.string().nullable(),
        hora_fim_diario: z.string().nullable(),
        intervalo_hora_inicio_diario: z.string().nullable(),
        intervalo_hora_fim_diario: z.string().nullable(),
    }).superRefine((data, ctx) => {
        if (!isValidDate(data.data)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Data inválida",
                path: ["data"],
            });
        }

        if (data.horario_especial_agendamento) {
            if (data.hora_inicio_agendamento.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Hora início agendamento é obrigatória",
                    path: ["hora_inicio_agendamento"],
                });
            } else {
                if (!isValidTime(data.hora_inicio_agendamento)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Hora início agendamento deve ser válida",
                        path: ["hora_inicio_agendamento"],
                    });
                }
            }

            if (data.hora_fim_agendamento.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Hora fim agendamento é obrigatória",
                    path: ["hora_fim_agendamento"],
                });
            } else {
                if (!isValidTime(data.hora_fim_agendamento)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Hora fim agendamento deve ser válida",
                        path: ["hora_fim_agendamento"],
                    });
                }
            }

            if (!isGreaterThanTime(data.hora_fim_agendamento, data.hora_inicio_agendamento)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Hora fim agendamento deve ser maior que a hora início agendamento",
                    path: ["hora_fim_agendamento"],
                });
            }

            if (data.intervalo_hora_inicio_agendamento.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Intervalo hora início agendamento é obrigatório",
                    path: ["intervalo_hora_inicio_agendamento"],
                });
            } else {
                if (!isValidTime(data.intervalo_hora_inicio_agendamento)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Intervalo hora início agendamento deve ser válido",
                        path: ["intervalo_hora_inicio_agendamento"],
                    });
                }
            }

            if (data.intervalo_hora_fim_agendamento.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Intervalo hora fim agendamento é obrigatório",
                    path: ["intervalo_hora_fim_agendamento"],
                });
            } else {
                if (!isValidTime(data.intervalo_hora_fim_agendamento)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Intervalo hora fim agendamento deve ser válido",
                        path: ["intervalo_hora_fim_agendamento"],
                    });
                }
            }

            if (!isGreaterThanTime(data.intervalo_hora_fim_agendamento, data.intervalo_hora_inicio_agendamento)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Intervalo hora fim agendamento deve ser maior que a hora início agendamento",
                    path: ["intervalo_hora_fim_agendamento"],
                });
            }
        }

        if (data.horario_especial_diario) {
            if (data.hora_inicio_diario.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Hora início diário é obrigatória",
                    path: ["hora_inicio_diario"],
                });
            } else {
                if (!isValidTime(data.hora_inicio_diario)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Hora início diário deve ser válida",
                        path: ["hora_inicio_diario"],
                    });
                }
            }

            if (data.hora_fim_diario.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Hora fim diário é obrigatória",
                    path: ["hora_fim_diario"],
                });
            } else {
                if (!isValidTime(data.hora_fim_diario)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Hora fim diário deve ser válida",
                        path: ["hora_fim_diario"],
                    });
                }
            }

            if (!isGreaterThanTime(data.hora_fim_diario, data.hora_inicio_diario)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Hora fim diário deve ser maior que a hora início diário",
                    path: ["hora_fim_diario"],
                });
            }

            if (data.intervalo_hora_inicio_diario.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Intervalo hora início diário é obrigatório",
                    path: ["intervalo_hora_inicio_diario"],
                });
            } else {
                if (!isValidTime(data.intervalo_hora_inicio_diario)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Intervalo hora início diário deve ser válido",
                        path: ["intervalo_hora_inicio_diario"],
                    });
                }
            }

            if (data.intervalo_hora_fim_diario.length < 5) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Intervalo hora fim diário é obrigatório",
                    path: ["intervalo_hora_fim_diario"],
                });
            } else {
                if (!isValidTime(data.intervalo_hora_fim_diario)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "Intervalo hora fim diário deve ser válido",
                        path: ["intervalo_hora_fim_diario"],
                    });
                }
            }

            if (!isGreaterThanTime(data.intervalo_hora_fim_diario, data.intervalo_hora_inicio_diario)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Intervalo hora fim diário deve ser maior que a hora início diário",
                    path: ["intervalo_hora_fim_diario"],
                });
            }
        }
    });
